<prism-select 
  [selectOptions]="options"
  [label]="label"
  placeHolder="Select a School"
  [control]="control"
  [required]="required"
  [readOnly]="readOnly"
  [allowDeselect]="true"
  [labelClass]="labelClass"
  (onSelected)="emitSchool($event)">
</prism-select>
